export const ADMIN_EMAILS = [
  "ricky@tailoredpackaging.net",
  "sales@tailoredpackaging.net",
  "tailoredpackaging2018@gmail.com",
];

export const isAdminEmail = (email) => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};
